import moment from "moment/moment";
import htmlToText from "html-to-text";

export default {
    MakePDF(prog, o_lectureTime, o_practiceTime, o_laboratoryTime, o_ikrTime, o_ktoTime, o_keTime, o_lessonTime, o_seminarTime,
            o_controlTime, o_indepTime, o_lectures, o_lesson, o_seminar, o_practice, o_laboratory, o_indepWork, z_control, z_timesc, z_lectureTime,
            z_practiceTime, z_laboratoryTime, z_ikrTime, z_ktoTime, z_keTime, z_controlTime, z_indepTime, z_indepWork, o_themes, z_themes) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        }
        moment.locale('ru');
        const htmlToText = require('html-to-text');
        let special = ""
        let profile = ""
        let control = ""
        let approval_dates = getDates(prog.updated_at)
        let first_theme = 'ЦЕЛИ И  ЗАДАЧИ ОСВОЕНИЯ ДИСЦИПЛИНЫ'
        let purpose = '\t\t Цель дисциплины:'
        let task = `\t\t Задачи дисциплины:`
        let comp_text = " "
        let department = []
        let disciplines = `дисциплины`
        if (prog.main_info.department !== null){
            department = prog.main_info.department.split(' ').slice(1);
        }
        if (prog.main_info.dep_manager === null){
            prog.main_info.dep_manager = ""
        }
        if (prog.main_info.speciality_code === '38.05.02' || prog.main_info.speciality_code === '37.05.01'){
            special = "Специальность"
            profile = "Направленность (профиль) программы специалитета"
        }
        else if (prog.main_info.speciality_code === '38.05.01'){
            special = "Специальность"
            profile = "Специализация программы специалитета"
        }
        else if (prog.main_info.speciality_code.split('.')[1] !== '05'){
            special = "Направление подготовки"
            profile = "Направленность (профиль) образовательной программы"
        }
        else{
            special = "Специальность"
            profile = "Специализация образовательной программы"
        }
        if (prog.main_info.exam.length){
            control += `Экзамен   ${ getPeriod(prog.main_info.exam) } сем      \n`
        }
        if (prog.main_info.credit.length){
            control += `Зачет    ${ getPeriod(prog.main_info.credit) } сем      \n`
        }
        if (prog.main_info.creator.title === null){
            prog.main_info.creator.title = ""
        }
        let n = 0
        let n_comp = 0
        let n_content = 0
        let z_times =  {
            "Экзамен": {input: z_control.input, period: z_control.period, used: z_control.used},
            "Зачет": {input: z_timesc.Зачет.input, period: z_timesc.Зачет.period, used: z_timesc.Зачет.used},
            "Зачет с оценкой": {input: z_timesc['Зачет с оценкой'].input, period: z_timesc['Зачет с оценкой'].period, used: z_timesc['Зачет с оценкой'].used},
        }

        function num(){
            n = n+1
            return n
        }
        function getInitial(fio){
            let initial = ""
            if (fio !== ""){
                fio = fio.replaceAll("  ", " ")
                fio = fio.trim();
                initial += fio.split(' ')[1][0];
                initial +="."
                initial += fio.split(' ')[2][0];
                initial +=". "
                initial += fio.split(' ')[0];
            }
            return initial
        }
        function getDates(date){
            const sunday = 0;
            const saturday = 6;
            var libDate = moment(date).subtract(3, 'days');
            var manageDate = moment(date).subtract(2, 'days');
            var umuDate = moment(date).subtract(1, 'days');
            var dates =[libDate, manageDate, umuDate];
            var newDates = []
            dates.forEach(function(day){
                if (moment(day).day() === sunday){
                    newDates.push(moment(day).subtract(1, 'days').format(' D   MMMM   YYYY '));
                }
                else {
                    newDates.push(moment(day).format(' D   MMMM   YYYY '))
                }
            })
            return newDates
        }
        function getPeriod(period){
            if (typeof period === "string"){
                return period
            }
            if (typeof period === "object"){
                return period.join()
            }
        }
        function buildTitle() {
            var body = [];
            var discipline = `по дисциплине`
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: 'РАБОЧАЯ ПРОГРАММА', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `«${prog.name.toUpperCase()}»`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: `${special} ${prog.main_info.speciality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `${profile} – ${prog.main_info.profile}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Квалификация выпускника – ${prog.main_info.quality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Год набора – ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Форма обучения – ${prog.main_info.edu_form}`, style: 'twelveNormal', border: [false, false, false, false]}],
                )
            }
            else{
                body.push(
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: 'РАБОЧАЯ ПРОГРАММА', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `«${prog.name.toUpperCase()}»`, alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                    [{text: `Научная специальность ${prog.main_info.speciality}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Год набора – ${prog.main_info.year}`, style: 'twelveNormal', border: [false, false, false, false]}],
                    [{text: `Год обучения – ${prog.main_info.period.join()}`, style: 'twelveNormal', border: [false, false, false, false]}],
                )
            }
            return body;
        }
        function buildTerm(){
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push([{text: 'Курс', style: 'twelveNormal', border: [false, false, false, false]}, {text: `${getPeriod(prog.main_info.course)}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, true]}, {text: 'Семестр', style: 'twelveNormal', border: [false, false, false, false]},{text: `${getPeriod(prog.main_info.period)}`, alignment:'center', style: 'twelveNormal', border: [false, false, false, true]}])
            }
            else{
                body.push([{text: '', style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            return body;
        }
        function buildControl() {
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: control, style: 'twelveNormalControl', border: [false, false, false, false]}],
                    [{text: `Общая трудоемкость дисциплины ${prog.main_info.load.hour} (академ. час),  ${prog.main_info.load.zet} (з.е)`, style: 'twelveNormal', border: [false, false, false, false]}],
                )
            }
            else{
                body.push([{text: `Общая трудоемкость дисциплины ${prog.main_info.load.hour} (академ. час),  ${prog.main_info.load.zet} (з.е)`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            return body;
        }
        function buildApproval() {
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Учебно-методическое управление`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Выпускающая кафедра`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Чалкина`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Н.А. Чалкина`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `${(prog.main_info.provisor.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `${getInitial(prog.main_info.provisor)}`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${approval_dates[2]}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${approval_dates[1]}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Центр цифровой трансформации и технического обеспечения`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `А.А. Тодосейчук`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${approval_dates[0]}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${approval_dates[0]}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],)
            }
            else {
                body.push(
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Зав. отделом докторантуры и аспирантуры`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Выпускающая кафедра`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Сизова`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `Е.С. Сизова`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `${(prog.main_info.provisor.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `${getInitial(prog.main_info.provisor)}`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `СОГЛАСОВАНО`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}],
                    [{text: `Научная библиотека`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}, {text: `Центр цифровой трансформации и технического обеспечения`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: `Петрович`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `О.В. Петрович`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}, {text: `Тодосейчук`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]},{text: `А.А. Тодосейчук`, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                    [{text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${moment(prog.updated_at).format('LL')}`, style: 'twelveNormal', colSpan: 2, alignment:'center', border: [false, false, false, true]},{},{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}],
                    [{text: ``, style: 'twelveNormal', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],
                    [{text: ``, style: 'twelveNormal', pageBreak: 'after', alignment:'center', colSpan: 6, border: [false, false, false, false]}, {},{},{},{},{}],)
            }
            return body;
        }
        function buildTheme(){
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{text: `\t   ${num()}. СТРУКТУРА ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `Общая трудоемкость ${disciplines} составляет ${prog.main_info.load.zet} зачетных единицы, ${prog.main_info.load.hour} академических часов. `, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `1 – № п/п`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `2 – Тема (раздел) ${disciplines}, курсовая работа (проект), промежуточная аттестация`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `3 – Семестр`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4 – Виды контактной работы и трудоемкость (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.1 – Л (Лекции)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.2 – Лекции в виде практической подготовки`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.3 – ПЗ (Практические занятия)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.4 – Практические занятия в виде практической подготовки`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.5 – ЛР (Лабораторные работы)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.6 – Лабораторные работы в виде практической подготовки`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.7 – ИКР (Иная контактная работа)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.8 – КТО (Контроль теоретического обучения)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.9 – КЭ (Контроль на экзамене)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `5 – Контроль (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `6 – Самостоятельная работа (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `7 – Формы текущего контроля успеваемости`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                )
            }
            else {
                body.push(
                    [{text: `\t   ${num()}. СТРУКТУРА ДИСЦИПЛИНЫ`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `Общая трудоемкость дисциплины составляет ${prog.main_info.load.zet} зачетных единицы, ${prog.main_info.load.hour} академических часов. `, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `1 – № п/п`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `2 – Тема (раздел) дисциплины`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `3 – Год обучения`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4 – Виды контактной работы и трудоемкость (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.1 – Л (Лекции)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.2 – ПЗ (Практические занятия)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `4.3 – Самостоятельная работа (в академических часах)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                    [{text: `5 – Формы текущего контроля успеваемости (по семестрам), Форма промежуточной аттестации (по семестрам)`, style: "twelveNormal", alignment: 'justify', border: [false, false, false, false]}],
                )
            }
            return body;
        }
        function buildTableTheme(data, columns) {
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push(
                    [{
                        text: '1', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '2', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '3', style: 'twelveNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '4', style: 'tenNormal', alignment: 'center', colSpan: 9, border: [true, true, true, true]
                    }, {}, {}, {}, {}, {}, {}, {}, {}, {
                        text: '5', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '6', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '7', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true] }],
                    [{},{},{},{text: `4.1`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.2`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.3`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.4`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.5`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.6`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.7`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.8`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.9`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}, {}, {}],
                )
                data.forEach(function(row) {
                    var dataRow = [];

                    columns.forEach(function(column) {
                        dataRow.push(
                            {text: row[column].toString(), style: 'tenNormal'})
                    });
                    body.push(dataRow);
                });

                body.push([{},{text: `Итого`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]},{},{text: `${o_lectureTime}`, style: 'tenNormal', alignment: 'center', colSpan: 2, border: [true, true, true, true]}, {}, {text: `${o_practiceTime}`, style: 'tenNormal', alignment: 'center', colSpan: 2, border: [true, true, true, true]}, {}, {text: `${o_laboratoryTime}`, style: 'tenNormal', alignment: 'center', colSpan: 2, border: [true, true, true, true]}, {}, {text: `${o_ikrTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_ktoTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_keTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_controlTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_indepTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}])
            }
            else{
                body.push([{text: ``, style: 'tenNormal', alignment: 'center', colSpan: 15, border: [false, false, false, false]},{},{},{},{},{},{},{},{},{},{},{},{},{},{}])
            }
            return body;
        }
        function buildTableThemeASP(data, columns) {
            var body = [];
            if (prog.main_info.speciality_code.length === 6 && prog.main_info.speciality_code.length === 7){
                body.push(
                    [{
                        text: '1', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '2', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '3', style: 'twelveNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }, {
                        text: '4', style: 'tenNormal', alignment: 'center', colSpan: 3, border: [true, true, true, true]
                    }, {}, {}, {
                        text: '5', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                    }],
                    [{},{},{},{text: `4.1`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.2`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `4.3`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}],
                )
                data.forEach(function(row) {
                    var dataRow = [];

                    columns.forEach(function(column) {
                        dataRow.push(
                            {text: row[column].toString(), style: 'tenNormal'})
                    });
                    body.push(dataRow);
                });
                if (prog.main_info.credit.length){
                    body.push([{},{text: `Итого`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]},{},{text: `${o_lectureTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_practiceTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_indepTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `Зачет`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}])
                }
                if (prog.main_info.exam.length){
                    body.push([{},{text: `Итого`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]},{},{text: `${o_lectureTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_practiceTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${o_indepTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `Экзамен - ${parseFloat(prog.main_info.load.hour) - o_practiceTime - o_lectureTime - o_indepTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}])
                }
            }
            else{
                body.push([{text: ``, style: 'tenNormal', alignment: 'center', colSpan: 7, border: [false, false, false, false]},{},{},{},{},{},{}])
            }
            return body;
        }
        function buildComp(){
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push([{text: `\t   ${num()}. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ${disciplines.toUpperCase()} И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ`, style: 'twelveBold', alignment: 'justify', colSpan: 4, border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            return body;
        }
        function buildCompetitionCat() {
            var body = [];
            if (prog.competition.UK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `${n}.${n_comp}. Универсальные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `Категория (группа) универсальных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.competition.UK.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.OPK_cat.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `${n}.${n_comp} Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `Категория (группа) общепрофессиональных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.competition.OPK_cat.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildCompetition() {
            var body = [];
            if (prog.competition.OPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.OPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.PK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.PK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.DPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `${n}.${n_comp} Дополнительные профессиональные компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование дополнительной профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения дополнительной профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.DPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildLectures() {
            var body = [];
            if (o_lectures.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Лекции`, style: "twelveBold", alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_lectures.forEach(function(lec) {
                    body.push([{text: `${o_lectures.indexOf(lec) + 1}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${lec.lecture_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(lec.lec_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }

        function buildLessons() {
            var body = [];
            if (o_lesson.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Уроки`, style: "twelveBold", alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_lesson.forEach(function(les) {
                    body.push([{text: `${o_lesson.indexOf(les) + 1}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${les.lesson_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(les.les_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }

        function buildSeminar() {
            var body = [];
            if (o_seminar.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Семинарские занятия`, style: "twelveBold", alignment: 'justify', colSpan: 3, border: [false, false, false, false]},{},{}])
                body.push([{text: `№ п/п`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_seminar.forEach(function(sem) {
                    body.push([{text: `${o_seminar.indexOf(sem) + 1}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${sem.seminar_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(sem.sem_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }
        function buildPractice() {
            var body = [];
            if (o_practice.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Практические занятия`, style: "twelveBold", alignment: 'justify', colSpan: 2, border: [false, false, false, false]},{}])
                body.push([{text: `Наименование темы`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Содержание темы`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_practice.forEach(function(prac) {
                    prac.practice_work.forEach(function(work) {
                        body.push([{text: `${work.work_name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: htmlToText.fromString(work.content, {
                                wordwrap: 10000,
                                tags: {
                                    'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                    'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                                },
                            }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                    });
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }
            return body;
        }
        function buildLaboratory() {
            var body = [];
            if (o_laboratory.length){
                n_content += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'center', border: [false, false, false, false]},{text: `\t\t ${n}.${n_content}. Лабораторные занятия`, style: "twelveBold", alignment: 'justify', colSpan: 2, border: [false, false, false, false]},{}])
                body.push([{text: `Наименование темы`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Содержание темы`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_laboratory.forEach(function(lab) {
                    lab.laboratory_work.forEach(function(work) {
                        body.push([{text: `${work.work_name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: htmlToText.fromString(work.content, {
                                wordwrap: 10000,
                                tags: {
                                    'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                    'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                                },
                            }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                    });
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildIndep() {
            var body = [];
            if (o_indepWork.length){
                body.push([{text: `№ п/п`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Трудоемкость в академических часах`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                o_indepWork.forEach(function(work) {
                    body.push([{text: `${o_indepWork.indexOf(work) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${work.indep_work_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(work.indep_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]},{text: `${work.indep_work}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }
        function buildSoftware() {
            var body = [];
            let n_soft = 0
            if (prog.software.length || prog.resources.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.software.forEach(function(soft) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${soft.info.license}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                prog.resources.forEach(function(res) {
                    n_soft += 1
                    body.push([{text: `${n_soft}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${res.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        function buildDataBases() {
            var body = [];
            if (prog.data_bases.length){
                body.push([{text: `№`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Описание`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                prog.data_bases.forEach(function(db) {
                    body.push([{text: `${prog.data_bases.indexOf(db) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${db.desc}`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
            }
            body.push([{text: ``, style: 'twelveNormal', colSpan: 3, alignment: 'center', border: [false, false, false, false]},{},{}])

            return body;
        }
        function buildZPreambula() {
            var body = [];
            if (z_times.Экзамен.used){
                body.push([{text: `Экзамен`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_times.Экзамен.period.join()} сем,`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `${z_times.Экзамен.input} акад. часа`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_times.Зачет.used){
                body.push([{text: `Зачет`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_times.Зачет.period.join()} сем,`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `${z_times.Зачет.input} акад. часа`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_times['Зачет с оценкой'].used){
                body.push([{text: `Зачет`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_times['Зачет с оценкой'].period.join()} сем,`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `${z_times['Зачет с оценкой'].input} акад. часа`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_lectureTime !== 0){
                body.push([{text: `Лекции`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_lectureTime}`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `(акад. часа)`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_practiceTime !== 0){
                body.push([{text: `Практические занятия`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_practiceTime}`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `(акад. часа)`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_laboratoryTime !== 0){
                body.push([{text: `Лабораторные работы`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_laboratoryTime}`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `(акад. часа)`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_ikrTime !== 0){
                body.push([{text: `ИКР`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_ikrTime}`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `(акад. часа)`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            if (z_indepTime !== 0){
                body.push([{text: `Самостоятельная работа`, style: 'twelveNormal', border: [false, false, false, false]},{text: `${z_indepTime}`, style: 'twelveNormal', alignment: 'center', border: [false, false, false, true]},{text: `(акад. часа)`, style: 'twelveNormal', border: [false, false, false, false]}])
            }
            body.push([{text: `Общая трудоемкость ${disciplines} составляет ${prog.main_info.load.hour} (акад. часа), ${prog.main_info.load.zet} (з.е.)`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            return body;
        }
        function buildTableZTheme(data, columns) {
            var body = [];
            body.push(
                [{
                    text: '№ п/п', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: `Тема (раздел) ${disciplines}, курсовая работа (проект), промежуточная аттестация`, style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: 'Cеместр', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: 'Виды контактной работы и трудоемкость (в академических часах)', style: 'tenNormal', alignment: 'center', colSpan: 6, border: [true, true, true, true]
                }, {}, {}, {}, {}, {}, {
                    text: 'Контроль (в академических часах)', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: 'Самостоятельная работа (в академических часах)', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true]
                }, {
                    text: 'Формы текущего контроля успеваемости', style: 'tenNormal', alignment: 'center', rowSpan: 2, border: [true, true, true, true] }],
                [{},{},{},{text: `Л`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `ПЗ`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `ЛР`, style: 'tenNormal', alignment: 'center',  border: [true, true, true, true]}, {text: 'ИКР', style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: 'КТО', style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: 'КЭ', style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}, {}, {}],
            )
            data.forEach(function(row) {
                var dataRow = [];

                columns.forEach(function(column) {
                    dataRow.push(
                        {text: row[column].toString(), style: 'tenNormal'})
                });
                body.push(dataRow);
            });

            body.push([{},{text: `Итого`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]},{},{text: `${z_lectureTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_practiceTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_laboratoryTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_ikrTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_ktoTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_keTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_controlTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {text: `${z_indepTime}`, style: 'tenNormal', alignment: 'center', border: [true, true, true, true]}, {}])
            body.push([{text: ``, style: 'twelveNormal', colSpan: 12, alignment: 'center', border: [false, false, false, false]},{},{},{},{},{},{},{},{},{},{},{}])

            return body;
        }
        function buildZIndep() {
            var body = [];
            if (z_indepWork.length){
                body.push([{text: `№ п/п`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Наименование темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Содержание темы (раздела)`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Трудоемкость в академических часах`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                z_indepWork.forEach(function(work) {
                    body.push([{text: `${z_indepWork.indexOf(work) + 1}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: `${work.indep_work_name}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(work.indep_content_old, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]},{text: `${work.indep_work}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 4, alignment: 'center', border: [false, false, false, false]},{},{},{}])
            }

            return body;
        }
        function buildEduTech(){
            var body = [];
            if (prog.main_info.speciality_code.split('.')[1] !== '02'){
                body.push([{text: `\t\t ${num()}. ОБРАЗОВАТЕЛЬНЫЕ ТЕХНОЛОГИИ`, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}])
            }
            else{
                body.push([{text: ``, style: "twelveBold", alignment: 'justify', border: [false, false, false, false]}])
            }
            return body;
        }
        let titlePage = {
            info: {
                title: `Рабочая программа ${disciplines} ${prog.main_info.discipline} ${prog.main_info.speciality} ${prog.main_info.year}`,
                author: 'ЦЦТиТО, АмГУ',
                subject: '',
                keywords: ''
            },
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins:[60,40,60,60],

            header:[],
            footer:[],
            content: [
                {
                    text: 'Министерство науки и высшего образования Российской Федерации \n Федеральное государственное бюджетное образовательное учреждение \n высшего образования \n "Амурский государственный университет"',
                    style: "twelveNormal", alignment: 'center',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [240,110,100],
                        heights: [8,'auto','auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal', colSpan: 3, border: [false, false, false, false]}, {},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'УТВЕРЖДАЮ', style: 'twelveNormal', colSpan: 2, lineHeight: 0.7, border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Проректор по учебной и научной работе', colSpan: 2, lineHeight: 0.7, style: 'twelveNormal', border: [false, false, false, false]},{}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:'Лейфа', alignment:'center', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{text:'А.В. Лейфа', style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, false]}],
                            [{text: '', style: 'eightNormal', border: [false, false, false, false]}, {text:`${moment().format(" D   MMMM   YYYY ")}`, colSpan: 2, style: 'twelveNormal', lineHeight: 0.7, border: [false, false, false, true]},{}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [50,'auto','auto',30],
                        body: buildTitle()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [30,50,45,50],
                        heights: ['auto','auto','auto'],
                        body: buildTerm()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [520],
                        heights: [10],
                        body: buildControl()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [50,'auto','auto'],
                        body: [
                            [{text: '', style: 'eightNormal',  border: [false, false, false, false]}],
                            [{text: `Составитель ${getInitial(prog.main_info.creator.fio)}, ${prog.main_info.creator.position}, ${prog.main_info.creator.title.replaceAll("ученая степень отсутствует", "")}`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.facility}`, style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.department}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [130],
                        body: [
                            [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `${prog.main_info.year}`, pageBreak: 'after', alignment:'center', style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    text: `${prog.main_info.basis} от ${prog.main_info.basis_date} № ${prog.main_info.basis_num}`, alignment:'justify', style: 'twelveNormal',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [20,20],
                        body: [
                            [{text:"", style: 'twelveNormal', border: [false, false, false, false]}],
                            [{text: `Рабочая программа обсуждена на заседании кафедры ${department.join(" ")}`,  style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [100,120],
                        heights: ['auto'],
                        body: [
                            [{text: `${prog.main_info.approval_date} г.`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `, протокол № ${prog.main_info.protocol_num}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [140,80,100],
                        heights: [10],
                        body: [
                            [{text: ``, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: ``, style: 'twelveNormal', colSpan: 2, border: [false, false, false, false]},{}],
                            [{text: `Заведующий кафедрой`, style: 'twelveNormal', alignment:'center', border: [false, false, false, false]}, {text: `${(prog.main_info.dep_manager.trim()).split(" ")[0]}`, style: 'twelveNormal', alignment:'center', border: [false, false, false, true]}, {text: `${getInitial(prog.main_info.dep_manager)}`, style: 'twelveNormal', border: [false, false, false, false]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [100,100,30,100,100,30],
                        heights: [100,'auto','auto',10],
                        body: buildApproval()
                    }
                },
                {
                    text: `\t\t ${num()}. ${first_theme}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `${purpose}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.purpose_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `${task}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.tasks_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}.  МЕСТО ${disciplines.toUpperCase()} В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.discipline_place_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildComp()
                    }
                },
                {
                    text: htmlToText.fromString(comp_text, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildCompetitionCat()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,150,290],
                        heights: [],
                        body: buildCompetition()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildTheme()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,75,10,15,15,15,15,15,15,15,15,15,25,25,65],
                        heights: [],
                        body: buildTableTheme(
                            o_themes,
                            ['num','name', 'period', 'lecture', 'lecture_pp', 'practice', 'practice_pp', 'laboratory', 'laboratory_pp', 'ikr', 'kto', 'ke', 'control', 'indep_work', 'control_form'],
                        )
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,120,15,45,45,45,140],
                        heights: [],
                        body: buildTableThemeASP(
                            o_themes,
                            ['num','name', 'period', 'lecture', 'practice', 'indep_work', 'control_form'],
                        )
                    }
                },
                {
                    text: `\t\t ${num()}. СОДЕРЖАНИЕ ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,5,150,280],
                        heights: [],
                        body: buildLectures()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,155,290],
                        heights: [],
                        body: buildPractice()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,155,290],
                        heights: [],
                        body: buildLaboratory()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,5,150,280],
                        heights: [],
                        body: buildLessons()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,5,150,280],
                        heights: [],
                        body: buildSeminar()
                    }
                },
                {
                    text: `\t\t ${num()}. САМОСТОЯТЕЛЬНАЯ РАБОТА`, style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [20,120,230,80],
                        heights: [],
                        body: buildIndep()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [500],
                        heights: [],
                        body: buildEduTech()
                    }
                },
                {
                    text: htmlToText.fromString(prog.edu_tech_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.eval_tool_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t ${num()}. УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t а) литература`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.literature_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags: {
                            'a': { options: {
                                    hideLinkHrefIfSameAsText: true,
                                    noLinkBrackets: true},
                            },
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                        },
                    }),
                    style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t б) программное обеспечение и Интернет-ресурсы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildSoftware()
                    }
                },
                {
                    text: `\t\t в) профессиональные базы данных и информационные справочные системы`, style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,130,305],
                        heights: [],
                        body: buildDataBases()
                    }
                },
                {
                    text: `\t\t ${num()}. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ ${disciplines.toUpperCase()}`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.structure_text_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify'
                },
            ],
            styles: {
                eightNormal: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false
                },
                tenNormal: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false
                },
                twelveNormal: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    preserveLeadingSpaces: true
                },
                twelveNormalControl: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    lineHeight: 1.5,
                },
                twelveBold: {
                    fontSize: 12,
                    font: 'Times',
                    bold: true,
                    preserveLeadingSpaces: true
                },
            }
        };
        if (prog.has_z_part){
            titlePage.content.push(
                {
                    text: 'ПРИЛОЖЕНИЕ К РАБОЧЕЙ ПРОГРАММЕ \n\n', style: "twelveBold", alignment: 'center', pageBreak: 'before'
                },
                {
                    text: 'В соответствии с учебным планом для заочной формы обучения предусмотрено  \n\n', style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [140,90,250],
                        heights: [],
                        body: buildZPreambula()
                    }
                },
                {
                    text: '\t\t СТРУКТУРА ДИСЦИПЛИНЫ', style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15, 77, 8, 20, 20, 20, 25, 25, 20, 40, 45, 65],
                        heights: [],
                        body: buildTableZTheme(
                            z_themes,
                            ['num','name', 'period', 'lecture', 'practice', 'laboratory', 'ikr', 'kto', 'ke', 'control', 'indep_work', 'control_form'],
                        )
                    }
                },
                {
                    text: '\t\t САМОСТОЯТЕЛЬНАЯ РАБОТА', style: "twelveBold", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [20,120,230,80],
                        heights: [],
                        body: buildZIndep()
                    }
                },
            )
        }
        pdfMake.createPdf(titlePage).download(`${prog.main_info.discipline} ${prog.main_info.speciality_code} ${prog.main_info.year}.pdf`);
    }
}